import { render } from "./ListadoPublicaciones.vue?vue&type=template&id=4f07bc6b&scoped=true"
import script from "./ListadoPublicaciones.vue?vue&type=script&lang=js"
export * from "./ListadoPublicaciones.vue?vue&type=script&lang=js"

import "./ListadoPublicaciones.vue?vue&type=style&index=0&id=4f07bc6b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f07bc6b"]])

export default __exports__